import { entries, flatten, map, pipe, reduce, snakeCase, uniq } from 'lodash/fp'

export const getBukImportErrorSummary = (err: any[]) => {
	const rowsErrors = map(
		pipe([
			entries,
			map(
				([key, val]: [string, string]) =>
					snakeCase(val[0]) + '::' + snakeCase(key)
			),
		])
	)(err) as unknown as string[]

	const getSummary = pipe([
		flatten,
		uniq,
		reduce(
			(acc, errHash: string) => ({
				...acc,
				[errHash]:
					rowsErrors.filter((row) => row.includes(errHash)).length || 0,
			}),
			{}
		),
		entries,
		map(([hash, rows]) => {
			const [error, field] = hash.split('::')

			return {
				error,
				field,
				rows,
			}
		}),
	])

	return getSummary(rowsErrors)
}
